/**
 * "NEW" markers for freshly shipped features. A feature stays highlighted
 * until the user has opened it once on this device. Storage can be missing
 * (private mode, cleared site data) — then the marker simply shows again,
 * which is harmless.
 */
export type NewFeature = 'wheel';

const KEY = (f: NewFeature) => `bog.seen.${f}`;

export function isNew(f: NewFeature): boolean {
    try { return localStorage.getItem(KEY(f)) !== '1'; } catch { return true; }
}

export function markSeen(f: NewFeature): void {
    try { localStorage.setItem(KEY(f), '1'); } catch { /* private mode */ }
}
